import { storeToOwnerEmail } from "../pages/dashboards/StoreManagement/constants";

import useAuth from "./useAuth";

const DECISIONS_ACTION = "decisions";

// Whether the user may respond to agent decisions on `store`, including the
// deal accept/reject those cards offer. The cookie path reads the store's
// grant; the legacy JWT path has only the hardcoded owner list.
const useCanRespondToDecisions = (store) => {
  const { method, user } = useAuth();
  if (!user || !store) return false;
  if (method === "cookie") {
    const grant = (user.stores ?? []).find((s) => s.code === store);
    return Boolean(
      grant &&
        (grant.role === "full_access" ||
          (grant.applications ?? []).includes(DECISIONS_ACTION))
    );
  }
  return Boolean(user.email && storeToOwnerEmail[store]?.includes(user.email));
};

export default useCanRespondToDecisions;
